import validate from "/home/vsts/work/1/s/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45auth_45global from "/home/vsts/work/1/s/middleware/01.auth.global.ts";
import _02_45must_45read_45global from "/home/vsts/work/1/s/middleware/02.mustRead.global.ts";
import manifest_45route_45rule from "/home/vsts/work/1/s/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45auth_45global,
  _02_45must_45read_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}